import { render, staticRenderFns } from "./ProfitAndCash.vue?vue&type=template&id=48c42582&scoped=true"
import script from "./ProfitAndCash.vue?vue&type=script&lang=js"
export * from "./ProfitAndCash.vue?vue&type=script&lang=js"
import style0 from "./ProfitAndCash.vue?vue&type=style&index=0&id=48c42582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c42582",
  null
  
)

export default component.exports